import * as React from 'react';
import {useDispatch} from 'react-redux';

import {expandButtonWithTimeout} from '../redux/glossary-actions';

import {CueCardStack} from './cue-card-stack';
import {useGetCueCardsForLocation, useDismissCueCard} from './helpers';

type Props = {
    glossaryKey?: string;
};

export function BannerCueCards(props: Props) {
    const dispatch = useDispatch();
    const {onDismiss} = useDismissCueCard();

    const glossaryKey = props.glossaryKey || window.location.pathname;

    const bannerCueCards = useGetCueCardsForLocation(glossaryKey, 'banner');

    if (!bannerCueCards) {
        return null;
    }

    return (
        <CueCardStack
            cards={bannerCueCards}
            withBottomMargin={true}
            onMinimize={(settingsKey: string) => {
                if (onDismiss) {
                    onDismiss(settingsKey);
                }

                // @ts-expect-error
                dispatch(expandButtonWithTimeout());
            }}
        />
    );
}
